import { render, staticRenderFns } from "./main3pv.vue?vue&type=template&id=07a491a7&scoped=true&"
import script from "./main3pv.vue?vue&type=script&lang=js&"
export * from "./main3pv.vue?vue&type=script&lang=js&"
import style0 from "./main3pv.vue?vue&type=style&index=0&id=07a491a7&prod&lang=css&"
import style1 from "./main3pv.vue?vue&type=style&index=1&id=07a491a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a491a7",
  null
  
)

export default component.exports